import { Brand } from '@omniafishing/core';
import { Input } from 'antd';
import { debounce } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getImgixPath } from '../../lib/imgix';
import { OmniaUrls } from '../../lib/urls';
import { getBrandsFeatured, getBrandsNotHidden } from '../../redux/reference_data';
import { normalizeBrandsText } from '../../routes/shop_page/shop_page_brands';
import { ContentWrapper } from '../content_wrapper/content_wrapper';
import styles from './brands_list.less';

export const BrandsList = () => {
  const brands = useSelector(getBrandsNotHidden);
  const brandsFeatured = useSelector(getBrandsFeatured);
  const [searchQuery, setSearchQuery] = useState('');

  const searchQueryWithSpace = normalizeBrandsText(searchQuery);
  const searchQueryWithoutSpace = searchQueryWithSpace.replace(/\s/g, '');

  const debouncedSearch = debounce((value) => {
    setSearchQuery(normalizeBrandsText(value));
  }, 300);

  const filteredFeaturedBrands = brandsFeatured.filter((brand) => {
    const normalizedBrandName = normalizeBrandsText(brand.display_name);
    return (
      normalizedBrandName.includes(searchQueryWithSpace) ||
      normalizedBrandName.includes(searchQueryWithoutSpace)
    );
  });

  const filteredBrands = brands.filter((brand) => {
    const normalizedBrandName = normalizeBrandsText(brand.display_name);
    return (
      normalizedBrandName.includes(searchQueryWithSpace) ||
      normalizedBrandName.includes(searchQueryWithoutSpace)
    );
  });

  const az = '#abcdefghijklmnopqrstuvwxyz'.split('');
  const azHash = az.reduce((acc, letter) => {
    acc[letter] = [];
    return acc;
  }, {} as Record<string, Brand[]>);

  filteredBrands.forEach((brand) => {
    let letter = brand.display_name[0].toLowerCase();
    if (letter === Number(letter).toString()) {
      letter = '#';
    }
    azHash[letter].push(brand);
  });

  return (
    <ContentWrapper tag="section" className={styles.wrapper}>
      <h1 className={styles.h1}>Brands</h1>
      <Input.Search
        placeholder="Search Brands"
        onChange={(e) => debouncedSearch(e.target.value)}
        style={{ marginBlock: 20 }}
        className={styles.search}
      />
      <ul className={styles.featuredList}>
        {filteredFeaturedBrands.map((brand) => (
          <li className={styles.featuredItem} key={brand.url_slug}>
            <Link to={OmniaUrls.brand(brand)}>
              <img src={getImgixPath(brand.image, { w: 375 })} alt={brand.display_name} />
            </Link>
          </li>
        ))}
      </ul>
      <ul className={styles.allBrands}>
        {Object.keys(azHash).map((letter) => {
          const letterBrands = azHash[letter];
          if (letterBrands.length) {
            return (
              <li key={letter}>
                {!searchQuery && <span className={styles.letter}>{letter}</span>}

                <ul className={styles.letterBrands}>
                  {letterBrands.map((brand, i) => {
                    const letterId = i === 0 ? letter : null;
                    return (
                      <li className={styles.allBrandsItem} key={brand.url_slug} id={letterId}>
                        <Link to={OmniaUrls.brand(brand)} className={styles.allBrandsLink}>
                          {brand.display_name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          }
        })}
      </ul>
    </ContentWrapper>
  );
};
